import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  agencysStore: [],
  dataOrigin: [],
};

export const agencysSlice = createSlice({
  name: 'agencysSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateAgencys: (state, action) => {
      state.agencysStore = action.payload;
    },
    updateDataOrigin: (state, action) => {
      state.dataOrigin = action.payload;
    },
  },
});

export const { updateAgencys, updateDataOrigin } = agencysSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const agencyState = (state: RootState) => state.agencys;

export default agencysSlice.reducer;
